import { Container } from '@mui/material';
import React, { useEffect, useState } from 'react';

import CertificateAutoView from 'commons/CertificateAutoView';

const CertificateCreateReview = () => {
  const [artwork, setArtwork] = useState(null);

  useEffect(() => {
    const handleRNMessage = (event) => {
      setArtwork(event.detail);
    };

    window.addEventListener('FROM_REACT_NATIVE', handleRNMessage);

    return () => {
      window.removeEventListener('FROM_REACT_NATIVE', handleRNMessage);
    };
  }, []);

  return (
    <Container sx={{ pt: 2, pb: 2 }}>
      <CertificateAutoView
        artwork={artwork}
        certificate={artwork?.certificate}
      />
    </Container>
  );
};

export default CertificateCreateReview;
